import { useState, useEffect } from "react";
import { Button, Empty , Form, Select,Input} from "antd";

import { DatePicker, Space } from 'antd';

import "./myLeaves.scss";
import FilterTimeSheet from "../filterTimeSheet";
import MyTimeSheetTable from "../MyTimeSheetTable";
import useMyTimeSheetStore from "../../store/mytimesheet";

const timeSheetTitlesLeaves = [
    "Select",
    "S. No.",
    "Leave Type",
    "Start Date",
    "Start Full/Half Day",
    "End Date", 
    "End Full/Half Day",
    "Number Of days",
    "Approval Status", //Accept, Reject, Pending,Cancelled
    "Approval Date",
    "Leave Req Date",
    "Actions",
    "Comments"
];


function MyLeaves( {currentView}) {
    
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedStartDateMode, setStartDateMode] = useState("Full Day");
    const [selectedEndDateMode, setEndDateMode] = useState("Full Day");
    const [selectedLeaveType, setLeaveType] = useState("");
    const [validLeaves, setValidLeaves] = useState(false);
    const [selectedTotalDays, setTotalDays] = useState(0);
    const [selectedFullDays, setFullDays] = useState(0);
    const [selectedHalfDays, setHalfDays] = useState(0);
    const [selectedReason, setReason] = useState("");

    const {applyLeave,getMyLeaveApplications,leaveUpdateFlag,resetLeaveFlag,myLeaveApplications,
           getMyLeavesConfigList,myLeaveConfigList,myUsedLeavesList} = useMyTimeSheetStore()

    const [selecteID, setID] = useState(0);// all

    const userData = JSON.parse(localStorage.getItem("userDetails"));           
    const today =  new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const date = today. getDate();
    const sat_mode = "HALF_DAY_WORKING"
    useEffect(() => {
        getMyLeavesConfigList()
        resetLeaveFlag()
        getMyLeaveApplications(year,month,date);
    }, []);

    useEffect(() => {
        if(leaveUpdateFlag){
            resetLeaveFlag();
            getMyLeaveApplications(year,month,date);
        }
    }, [leaveUpdateFlag]);

    const leaveData = myLeaveConfigList?.map((member) => {
        return {
            value:member.qhlconfigid,
            label:member.year,
        };
    }); 

    const leaveNamesList = myLeaveConfigList?.[selecteID]?.leavesarray?.map((item, idx) => {
            return {
                value:item.leavetype,
                label:item.leavetype,
            }    
    })

    useEffect(() => {
        const today = new Date();
        const year = today.getFullYear();
        for( var i=0; i < leaveData?.length ; i++){
            if(leaveData[i].year == year){
               setID(i) 
               break; 
            }
        }          
    }, [myLeaveConfigList]);


    const isValid = (value) =>{
        if ((value == null) || (value == undefined) || (value == "")){
            return false
        }else{
            return true
        }
    }

   const myLeavesData = myLeaveApplications?.map((app, idx) => {
        return {
            select:"",
            id:idx+1,
            leavetype:app?.req.leavetype,
            startday:app.req?.leavestartdate,
            startdaymode:app.req?.leavestartdaymode, //NO LEAVE,SICK_LEAVE,HOLIDAY, EL,LOP
            enddate:app.req?.leaveenddate,
            enddatemode:app.req?.leaveenddaymode,
            numdays:app.req?.numleavesfulldays  + (app.req?.numleaveshalfdays)*0.5,
            approvalstatus:app.leaveapprovalstatus,
            approvaldate:app.leaveapprovaldate,
            leavereqdate:app.req?.leaveapplicationdate,                        
            actions:"CANCEL",
            comments: "", 
        };
    }); 

   const getUsedLeaves = (item) =>{
     if(selecteID > myUsedLeavesList?.length){
        return 0
     }
     for (var i=0; i < myUsedLeavesList?.[selecteID]?.info?.length; i++){
        if(myUsedLeavesList?.[selecteID].info?.[i].leavetype == item.leavetype){
            return myUsedLeavesList?.[selecteID].info?.[i].usedleaves
        }
     }
     return 0
   }
   const getTotalUsedLeaves = () =>{
     var totalusedLeaves = 0
     if(selecteID > myUsedLeavesList?.length){
        return 0
     }
     for (var i=0; i <myUsedLeavesList?.[selecteID]?.info?.length; i++){
        totalusedLeaves = totalusedLeaves + myUsedLeavesList?.[selecteID].info?.[i].usedleaves
     }

     return totalusedLeaves
   }
   const leavesListNew = myLeaveConfigList?.[selecteID]?.leavesarray?.map((item, idx) => {
            return {
                    id: idx + 1,
                    type: item.leavetype,
                    available: item.maxleaves,
                    used:getUsedLeaves(item),
                    carryforward: item.carryforward,
            }})

    const handleDate  = (type,date,dateString) =>{
        console.log("Selected Date", dateString)
        if(type == "START"){
            setStartDate(dateString)
            checkAvailableLeaves (selectedLeaveType,dateString,endDate,selectedStartDateMode,selectedEndDateMode)  
        }else{
            setEndDate(dateString)
            checkAvailableLeaves (selectedLeaveType,startDate,dateString,selectedStartDateMode,selectedEndDateMode)  
        }
    }
    
    function getWorkingDays(startDateStr, endDateStr, saturday, holidays = []) {
    let start = new Date(startDateStr);
    let end = new Date(endDateStr);

    if (start > end) [start, end] = [end, start]; // ensure correct order

    // Normalize holidays → "YYYY-MM-DD"
    const holidaySet = new Set(
        holidays?.map(d => new Date(d).toISOString().split("T")[0])
    );

    let total = 0;

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        
        const day = d.getDay(); // 0 = Sun, 6 = Sat
        const dateStr = d.toISOString().split("T")[0];
        // Skip if holiday
        if (holidaySet?.has(dateStr)) continue;

        if (day === 0) continue; // Sunday = full holiday

        if ((day === 6)&&(saturday == "HALF_DAY_WORKING")) total += 0.5; // Saturday = half day
        else if ((day === 6)&&(saturday == "FULL_DAY_WORKING")) total += 1; // Saturday = FULL day Working
        else if (day === 6){
            continue; //Saturday= Full Holiday
        }else
            total += 1;
    }

    return total;
    }

    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }
    function convertToDDMMYYYY(dateStr) {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    }   

    const checkAvailableLeaves =(leavetype, sdate,edate,smode,emode) =>{
        let encodedJsonValues = {};

        encodedJsonValues.leavestartdatets = -1; 
        encodedJsonValues.leaveenddatets = -1; 

        if ((sdate !=undefined) && (sdate != "")) {
            encodedJsonValues.leavestartdate = convertToDDMMYYYY(sdate); 
            const datest = new Date(sdate); // yyyy-mm-dd format.. Note : Please be carefull it expects only this format
            const unixTimestampst = Math.floor(datest.getTime() / 1000); // in seconds  
            encodedJsonValues.leavestartdatets = unixTimestampst; 
        }

        if(smode == ""){
            encodedJsonValues.leavestartdaymode = "Full Day"
        }else{
            encodedJsonValues.leavestartdaymode = smode; 
        }
        encodedJsonValues.leaveenddate = convertToDDMMYYYY(endDate); 
        
        if(edate != undefined && edate != ""){
            if(emode == ""){
                encodedJsonValues.leaveenddaymode = "Full Day"
            }else{
                encodedJsonValues.leaveenddaymode = emode; 
            }            
        }
        encodedJsonValues.leavetype = leavetype; 
        
        if(edate == undefined || edate == ""){
            if(smode != "Full Day"){
                encodedJsonValues.numleaveshalfdays = 1;
                encodedJsonValues.numleavesfulldays = 0; 
            }else{
                encodedJsonValues.numleaveshalfdays = 0;
                encodedJsonValues.numleavesfulldays = 1; 
            } 
        }else{
            const dateend = new Date(edate); // yyyy-mm-dd format
            const unixTimestampend = Math.floor(dateend.getTime() / 1000); // in seconds         
            encodedJsonValues.leaveenddatets = unixTimestampend; 

            encodedJsonValues.numleavesfulldays = getWorkingDays(sdate,edate,sat_mode); 
            encodedJsonValues.numleaveshalfdays = 0;  
            if(smode != "Full Day"){
                encodedJsonValues.numleavesfulldays =  encodedJsonValues.numleavesfulldays-1;
                encodedJsonValues.numleaveshalfdays = 1; 
            } 
            if(emode != "Full Day"){
                encodedJsonValues.numleavesfulldays =  encodedJsonValues.numleavesfulldays-1;
                encodedJsonValues.numleaveshalfdays = 2; 
            }              
       }

       console.log("check both", encodedJsonValues.leavestartdatets,encodedJsonValues.leaveenddatets)
       if((encodedJsonValues.leavestartdatets != -1) && (encodedJsonValues.leaveenddatets != -1)){
            if(encodedJsonValues.leaveenddatets < encodedJsonValues.leavestartdatets ){
                setTotalDays(0)
                setValidLeaves(false)
                setReason("")
                setHalfDays(0)
                setFullDays(0)                   
                return
            }
       }

       console.log("start date",sdate)
       if((sdate != "")&&(sdate != undefined)){
            var totalLeaves = encodedJsonValues.numleavesfulldays + (encodedJsonValues.numleaveshalfdays/2)
            setTotalDays(totalLeaves) 
            setHalfDays(encodedJsonValues.numleaveshalfdays)
            setFullDays(encodedJsonValues.numleavesfulldays)     
            console.log("Recalculating",totalLeaves, leavetype)
       }else{
            setTotalDays(0) 
            setHalfDays(0)
            setFullDays(0)     
       }
       
       console.log("leave type",leavetype)
       if(leavetype != ""){
            var tmList = leavesListNew.filter((item)=> item.type == leavetype )
            if((totalLeaves + tmList?.[0]?.used <= tmList?.[0]?.available )&(totalLeaves>0)){
                    setValidLeaves(true)
                    setReason("")
            }else{
                    if(totalLeaves>0){
                        var delta = tmList?.[0]?.available - tmList?.[0]?.used
                        setValidLeaves(false)
                        setReason("Selected Leaves > Available Leaves. Available Leaves are " + delta )
                    }else{
                        setValidLeaves(false)
                        setReason("")
                    }
            }
       }else{
            setValidLeaves(false)
            setReason("")
       }
    }
    const handleFormSubmit= (value) => {
       
        let encodedJsonValues = {};

        encodedJsonValues.action = "APPLY"; 
        encodedJsonValues.username = userData.username;
        encodedJsonValues.qhuid = userData.qhuid; 

        encodedJsonValues.leavestartdate = convertToDDMMYYYY(startDate);
        const datest = new Date(startDate); // yyyy-mm-dd format.. Note : Please be carefull it expects only this format
        const unixTimestampst = Math.floor(datest.getTime() / 1000); // in seconds  
        encodedJsonValues.leavestartdatets = unixTimestampst; 
        
        if(value.leavestartdaymode == undefined){
            encodedJsonValues.leavestartdaymode = "Full Day"
        }else{
            encodedJsonValues.leavestartdaymode = value.leavestartdaymode; 
        }
        encodedJsonValues.leaveenddate = convertToDDMMYYYY(endDate); 
        if(endDate != undefined && endDate != ""){
            const dateend = new Date(endDate); // yyyy-mm-dd format
            const unixTimestampend = Math.floor(dateend.getTime() / 1000); // in seconds         
            encodedJsonValues.leaveenddatets = unixTimestampend; 

            if(value.leaveenddaymode == undefined){
                encodedJsonValues.leaveenddaymode = "Full Day"
            }else{
                encodedJsonValues.leaveenddaymode = value.leaveenddaymode; 
            }            
        }
        encodedJsonValues.leavetype = value.leavetype; 
        encodedJsonValues.leavereason = value.leavereason;
        
        encodedJsonValues.numleaveshalfdays = selectedHalfDays;
        encodedJsonValues.numleavesfulldays = selectedFullDays;         

        encodedJsonValues.leaveapplicationdate = getTimeNow();
        console.log("Leaves Encoded JSON",encodedJsonValues) 
        applyLeave({...encodedJsonValues});
    };

    const handleDayMode = (dayStr, value) =>{
        if(dayStr == "End"){
           setEndDateMode (value)
           checkAvailableLeaves (selectedLeaveType,startDate,endDate,selectedStartDateMode,value)
        }else{
           setStartDateMode (value)
           checkAvailableLeaves (selectedLeaveType,startDate,endDate,value,selectedEndDateMode)
        }
    }
    const handleLeaveType = (value) =>{
        setLeaveType(value)
        checkAvailableLeaves (value,startDate,endDate,selectedStartDateMode,selectedEndDateMode)
    }    
    return (
        <div className="myleaves-container">
            <div className="myleaves-members-wrapper">
                    <h4 className="timesheet-members-list-title">My Leaves</h4>
                    <div className="leaves-members-line" >
                        <div className="leaves-members-item-line" >    
                                Period : Jan { myLeaveConfigList?.[selecteID].year} to Dec { myLeaveConfigList?.[selecteID].year}         
                        </div>                         
                        <div className="leaves-members-item-line" >    
                                Total Used Leaves : { getTotalUsedLeaves()}        
                        </div>                      
                        <div className="leaves-members-item-line" >    
                                Available Leaves : { myLeaveConfigList?.[selecteID].totalleaves}          
                        </div> 
                    </div>
                                                                                                    
                    <div className="leave-numbers-wrapper">
                        {leavesListNew?.map((leave, i) => (
                                    <div className="leave-dual-display-wrapper">
                                        <div className="input-heading-number" >    
                                            {leave.used}/{leave.available}                   
                                        </div> 
                                        <div className="input-heading-style" >    
                                            {leave.type}               
                                        </div> 
                                    </div>
                        
                        ))}
                    </div>  
                <div className="leaves-members-just-heading">
                    Leave Application
                </div>
                <div className="leave-application-form-wrapper">
                    <div className="form">
                    <Form
                        name="leave-form"
                        justify="start"
                        layout="vertical"
                        autoComplete="off"
                        onFinish={handleFormSubmit}
                    >
                       <div className="leave-dual-input-wrapper">
                            <Form.Item
                                name="leavestartdate"
                                required={true}
                                label="Start Date"
                            >
                                <Space direction="vertical">
                                    <DatePicker onChange={(date,dateString)=>handleDate("START",date,dateString)}/>
                                </Space>                            
                            </Form.Item> 

                            <Form.Item
                                name="leavestartdaymode"
                                required={true}
                                label="Full Day / Half Day"
                            >
                                <Select
                                        required={true}
                                        name="leavestartdaymode"
                                        onChange={(value)=>handleDayMode("Start",value)} 
                                        placeholder={'Full Day'}                           
                                        options={[
                                            { value: 'Full Day', label: 'Full Day' },
                                            { value: 'First Half', label: 'First Half' },
                                            { value: 'Second Half', label: 'Second Half' },
                                        ]}
                                />                             
                            </Form.Item> 
                       </div>
                       
                        <div className="leave-dual-input-wrapper">
                            <Form.Item
                                name="leaveenddate"
                                required={true}
                                label="End Date"
                            >
                                <Space direction="vertical">
                                    <DatePicker onChange={(date,dateString)=>handleDate("END",date,dateString)}/>
                                </Space>                            
                            </Form.Item> 

                            <Form.Item
                                name="leaveenddaymode"
                                required={true}
                                label="Full Day / Half Day"
                            >
                                <Select
                                        required={true}
                                        name="leaveenddaymode"
                                        placeholder={'Full Day'}
                                        onChange={(value)=>handleDayMode("End",value)}                            
                                        options={[
                                            { value: 'Full Day', label: 'Full Day' },
                                            { value: 'First Half', label: 'First Half' },
                                        ]}
                                />                             
                            </Form.Item>
                        </div>
                        <div className="leave-dual-input-wrapper">                           
                        </div> 
                            <Form.Item
                                name="leavetype"
                                rules={[
                                    { required: true, message: 'Please select Leave Type!' }
                                ]}  
                                label="Leave Type"
                            >
                                <Select
                                        name="leavetype"   
                                        onChange={(value)=>handleLeaveType(value)}                       
                                        options={leaveNamesList}
                                />                             
                            </Form.Item>                                                
                            <Form.Item
                                    name="leavereason"
                                    label="Reason for Taking Leave"
                                >
                                    <Input  />
                                </Form.Item>  
                        
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled = {!validLeaves}
                        >
                            Apply Leave
                        </Button>                        
                    </Form>                          
                    </div>
                    <div className="output">
                            {selectedTotalDays?selectedTotalDays + " ":"0 "} Days Selected   
                            <br></br>
                            <br></br>
                            {selectedReason}   
                    </div>

                </div>                 
                                                                           
                    <FilterTimeSheet
                        filtername = {"getAllJdsInternalConsolidatedStats"}
                            initDuration={"24"}
                            initPrio={"All"}
                            initResume={"All"}
                            initJDStatus={"Active"}    
                            enableMonths    
                            handleFilter={null}
                    />     
                    <div className="timesheet-members-table">
                        {myLeaveApplications?.length > 0 ? (
                                <MyTimeSheetTable
                                    titleList={timeSheetTitlesLeaves}
                                    currentView = {currentView}
                                    data={myLeavesData}
                                    extraData = {myLeaveApplications}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesLeaves.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                    </div>                                                                         
            </div>
        </div>
    );
}

export default MyLeaves;
